// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"bee_a bhl_rh bhl_ri bhl_vf bhl_ec bhl_vc bhl_gs bhl_kf"};